(function () {
  function revealKBeautySections() {
    var items = document.querySelectorAll('.kb-fade:not(.is-visible)');
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (item) { item.classList.add('is-visible'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.16 });
    items.forEach(function (item) { observer.observe(item); });
  }
  document.addEventListener('DOMContentLoaded', revealKBeautySections);
  document.addEventListener('shopify:section:load', revealKBeautySections);
})();
